// extracted by mini-css-extract-plugin
module.exports = {"stepsList":"StepsList_stepsList__cwxFL","step":"StepsList_step__jEFT0","stepDark":"StepsList_stepDark__aaNJo"};